var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 430,
    viewBox: "0 0 483 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M339.285 397.235H167.058C152.959 397.235 141.625 385.9 141.625 371.802V55.8219V28.7301C141.625 14.6312 152.959 3.29688 167.058 3.29688H339.562C353.66 3.29688 364.995 14.6312 364.995 28.7301V371.802C364.718 385.9 353.384 397.235 339.285 397.235Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 5.52895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.055 381.476C161.802 381.476 157.379 377.052 157.379 371.8V28.7284C157.379 23.4759 161.802 19.0527 167.055 19.0527H339.558C344.81 19.0527 349.234 23.4759 349.234 28.7284V371.8C349.234 377.052 344.81 381.476 339.558 381.476H167.055Z",
    stroke: "currentColor",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.052 373.739C165.947 373.739 165.117 372.909 165.117 371.804V28.732C165.117 27.6262 165.947 26.7969 167.052 26.7969H339.556C340.661 26.7969 341.491 27.6262 341.491 28.732V371.804C341.491 372.909 340.661 373.739 339.556 373.739H167.052Z",
    stroke: "currentColor",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.621 55.8262H364.714",
    stroke: "currentColor",
    strokeWidth: 5.52895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.621 342.502H364.714",
    stroke: "currentColor",
    strokeWidth: 5.52895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.465 362.955H274.867",
    stroke: "currentColor",
    strokeWidth: 5.52895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.117 131.852C185.851 106.142 217.642 89.832 253.304 89.832C288.966 89.832 320.481 106.142 341.491 131.852",
    stroke: "currentColor",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.715 182.992C364.991 183.822 364.991 184.927 365.268 185.757C366.097 191.562 366.65 197.367 366.65 203.173C366.65 206.767 366.374 210.637 366.097 214.231C365.821 217.272 365.268 220.589 364.715 223.63",
    stroke: "currentColor",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.117 274.777C185.851 300.487 217.642 316.797 253.304 316.797C288.966 316.797 320.481 300.487 341.491 274.777",
    stroke: "currentColor",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.624 183.273C141.624 183.826 141.347 184.656 141.347 185.209C141.071 186.038 141.071 186.867 141.071 187.697C140.794 189.908 140.518 192.396 140.241 194.608C139.965 197.372 139.965 200.413 139.965 203.178C139.965 210.089 140.518 216.724 141.624 223.358",
    stroke: "currentColor",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.117 145.124C183.916 116.65 216.536 97.8516 253.304 97.8516C290.072 97.8516 322.416 116.65 341.491 145.401",
    stroke: "currentColor",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.117 261.506C183.916 289.98 216.536 309.055 253.304 309.055C290.072 309.055 322.416 290.256 341.491 261.506",
    stroke: "currentColor",
    strokeWidth: 2.07336,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 264,
    r: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.765 264C75.765 237.957 96.9571 216.765 123 216.765C149.043 216.765 170.235 237.957 170.235 264C170.235 290.043 149.043 311.235 123 311.235C96.9571 311.235 75.765 290.043 75.765 264Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 5.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.909 252.649C108.815 252.649 111.179 254.878 111.179 257.919H116.584C116.584 251.837 111.795 247.244 105.909 247.244C100.023 247.244 95.2344 251.837 95.2344 257.919H100.64C100.64 254.878 103.004 252.649 105.909 252.649Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09 252.149C137.078 252.149 134.586 254.351 134.34 257.419H129.926C130.18 251.87 134.636 247.744 140.09 247.744C145.543 247.744 150 251.87 150.253 257.419H145.839C145.594 254.351 143.102 252.149 140.09 252.149Z",
    fill: "currentColor",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.904 291.702C133.362 291.702 143.384 286.354 149.122 277.475L144.582 274.541C139.313 282.695 129.671 287.245 120.023 286.131C112.502 285.264 105.547 280.931 101.417 274.541L96.8774 277.475C101.874 285.207 110.295 290.451 119.403 291.501C120.573 291.636 121.74 291.702 122.904 291.702Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.448 161.069C280.621 155.483 270.69 153 258.897 153H221.655V223.759H208V236.793H221.655V247.345H235.31V236.793H264.483V223.759H235.31V215.69H258.897C271.31 215.69 280.621 213.207 287.448 207.621C294.276 202.034 298 194.586 298 184.034C298 174.103 294.276 166.655 287.448 161.069ZM277.517 199.552C273.172 203.276 266.966 205.138 258.897 205.138H235.31V164.793H258.897C266.966 164.793 273.172 166.655 278.138 169.759C282.483 172.862 284.965 177.828 284.965 184.655C284.345 190.862 281.862 195.828 277.517 199.552Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.544 105.556V137.415C418.644 143.455 416.855 144.947 411.124 145H384.857H358.591C352.628 144.954 351.066 143.218 351.171 137.415V105.556C347.893 105.668 346.857 104.874 347.016 101.308V92.8119C346.999 88.8855 348.181 88.2938 351.171 88.2606H384.857C371.056 87.9571 359.322 87.9571 356.81 81.5854C355.633 78.6011 355.919 74.9101 356.81 72.1794C357.7 69.4487 360.758 67.1499 364.23 67.0212C373.431 67.0212 378.879 80.7057 384.857 88.2606C391.492 78.9391 396.581 66.4143 405.782 67.0212C409.937 67.628 410.887 69.1961 412.608 72.1794C413.795 76.1238 413.877 78.2805 412.608 81.5854C410.127 87.0202 402.155 87.8399 384.857 88.2606H418.544C422.211 88.2921 423.049 89.4399 422.996 92.8119V101.004C423.069 104.289 422.19 105.363 418.544 105.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.171 105.556H418.544M351.171 105.556V137.415C351.066 143.218 352.628 144.954 358.591 145H384.857M351.171 105.556C347.893 105.668 346.857 104.874 347.016 101.308V92.8119C346.999 88.8855 348.181 88.2938 351.171 88.2606H384.857M418.544 105.556V137.415C418.644 143.455 416.855 144.947 411.124 145H384.857M418.544 105.556C422.19 105.363 423.069 104.289 422.996 101.004V92.8119C423.049 89.4399 422.211 88.2921 418.544 88.2606H384.857M384.857 88.2606C391.492 78.9391 396.581 66.4143 405.782 67.0212C409.937 67.628 410.887 69.1961 412.608 72.1794C413.795 76.1238 413.877 78.2805 412.608 81.5854C410.127 87.0202 402.155 87.8399 384.857 88.2606ZM384.857 88.2606C378.879 80.7057 373.431 67.0212 364.23 67.0212C360.758 67.1499 357.7 69.4487 356.81 72.1794C355.919 74.9101 355.633 78.6011 356.81 81.5854C359.322 87.9571 371.056 87.9571 384.857 88.2606ZM384.857 88.2606C384.857 110.419 384.857 122.842 384.857 145",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.485 90.535C384.485 90.535 394.049 71.4895 401.555 72.0186C404.945 72.5476 405.72 73.9146 407.124 76.5155C408.092 79.9542 408.16 81.8344 407.124 84.7156L384.485 90.535ZM384.485 90.535C384.485 84.7156 375.163 72.0186 367.657 72.0186C364.825 72.1308 362.331 74.1349 361.604 76.5155C360.878 78.8961 360.645 82.1139 361.604 84.7156L384.485 90.535ZM384.485 90.535C384.485 90.535 384.485 120.683 384.485 140M384.485 140H405.913C410.589 139.954 412.048 138.653 411.966 133.387V105.613H384.485H357.004V133.387C356.918 138.447 358.193 139.96 363.057 140H384.485ZM353 94V99.5C352.971 101.371 353.357 101.983 355 102H415C416.638 101.92 417.039 101.334 417 99.5V94C417.028 92.5082 416.594 92.0134 415 92H355C353.559 92.0564 353.198 92.6922 353 94Z",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardShop);
export default __webpack_public_path__ + "static/media/rewardShop.82406d30.svg";
export { ForwardRef as ReactComponent };